import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {DialogData} from '../../models/dialog.model';
import {DialogType} from '../../constants/dialog-constants';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogComponent implements OnInit {

  public title;
  public type: DialogType;
  public message;
  public description;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.title = data.title;
    this.message = data.message;
    this.description = data.description;
    this.type = data.type;
  }

  ngOnInit(): void {
  }

  isChoiceBased(): boolean {
    return this.type === DialogType.PLAIN;
  }

}
